import { createSvgIcon } from "@mui/material";

export const BellWithDotIcon = createSvgIcon(
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.35419 21.8018C10.0593 22.4241 10.9856 22.8018 12 22.8018C13.0145 22.8018 13.9407 22.4241 14.6458 21.8018M18 8.80176C18 7.21046 17.3679 5.68434 16.2427 4.55912C15.1174 3.4339 13.5913 2.80176 12 2.80176C10.4087 2.80176 8.8826 3.4339 7.75738 4.55912C6.63216 5.68434 6.00002 7.21046 6.00002 8.80176C6.00002 11.8919 5.22049 14.0077 4.34968 15.4072C3.61515 16.5876 3.24788 17.1779 3.26134 17.3425C3.27626 17.5248 3.31488 17.5944 3.46179 17.7033C3.59448 17.8018 4.19261 17.8018 5.38887 17.8018H18.6112C19.8074 17.8018 20.4056 17.8018 20.5382 17.7033C20.6852 17.5944 20.7238 17.5248 20.7387 17.3425C20.7522 17.1779 20.3849 16.5876 19.6504 15.4072C18.7795 14.0077 18 11.8919 18 8.80176Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="19" cy="6.80176" r="4" fill="#EF5350" />
  </svg>,
  "BellWithDotIcon",
);
